import React from 'react';
import { Box, Skeleton } from '@mui/material';


export const FormListSkeleton: React.FC<{ rows?: number }> = ({ rows = 5 }) => (
  <Box className="admin-page form-list-page">
    <Box className="form-list-top">
      <Box className="form-list-header">
        <Box>
          <Skeleton variant="text" width={92} height={28} />
          <Skeleton variant="text" width={260} height={18} />
        </Box>
        <Skeleton variant="rounded" width={168} height={38} />
      </Box>

      <Box className="form-list-toolbar">
        <Box className="form-list-toolbar-primary">
          <Skeleton variant="rounded" width={260} height={38} />
          <Skeleton variant="rounded" width={252} height={38} />
        </Box>
        <Skeleton variant="rounded" width={140} height={38} />
      </Box>
    </Box>

    <Box className="form-list-scroll">
      <Box className="form-list-rows">
        {Array.from({ length: rows }).map((_, index) => (
          <Box className="form-list-row" key={index}>
            <Box className="form-list-row-inner">
              <Box className="form-list-row-main">
                <Skeleton variant="rounded" width={38} height={38} />
                <Box className="form-list-row-text" sx={{ flex: 1 }}>
                  <Skeleton variant="text" width="42%" height={20} />
                  <Skeleton variant="text" width="62%" height={16} />
                </Box>
              </Box>
              <Box className="form-list-row-actions">
                <Skeleton variant="rounded" width={72} height={30} />
                <Skeleton variant="rounded" width={124} height={30} />
                <Skeleton variant="rounded" width={94} height={30} />
                <Skeleton variant="circular" width={34} height={34} />
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  </Box>
);
